import { ChargePointLocation } from '../../../stores/small-biz-store.model';
import { Injectable } from '@angular/core';
import { ProductsStoreService } from '../../../stores/products-store.service';
import { combineLatest, Observable, of } from 'rxjs';
import { Product } from '@app/shared/modules/evc-api/models/product';
import { map } from 'rxjs/operators';
import { ChargePointType, ChargingStationConfig } from '../../../stores/small-biz-store.model';

@Injectable({
  providedIn: 'root',
})
export class ChargingStationPricing {
  constructor(private products: ProductsStoreService) {}

  public mininumPrice$(): Observable<number> {
    return this.for$({
      amount: 1,
      type: ChargePointType.connect30,
      location: ChargePointLocation.wallInside30,
      smart: false,
    });
  }

  public for$(solution: ChargingStationConfig): Observable<number> {
    return combineLatest([
      this.typeCostOf$(solution),
      this.locationCostOf$(solution),
      this.smartOptionCostOf$(solution),
    ]).pipe(
      map(([typeCost, locationCost, smartOptionCost]) => (typeCost + locationCost + smartOptionCost) * solution.amount)
    );
  }
  public breakdownFor$(
    solution: ChargingStationConfig
  ): Observable<{ typeCost: number; locationCost: number; smartOptionCost: number }> {
    return combineLatest([
      this.typeCostOf$(solution),
      this.locationCostOf$(solution),
      this.smartOptionCostOf$(solution),
    ]).pipe(map(([typeCost, locationCost, smartOptionCost]) => ({ typeCost, locationCost, smartOptionCost })));
  }

  private typeCostOf$(solution: ChargingStationConfig): Observable<number> {
    return this.priceOf(this.products.findByChargePointType(solution.type));
  }

  private priceOf(product$: Observable<Product>): Observable<number> {
    return product$.pipe(map((product) => +product?.price || 0));
  }

  private locationCostOf$(solution: ChargingStationConfig) {
    return this.priceOf(this.products.findByLocation(solution.location));
  }

  private smartOptionCostOf$(solution: ChargingStationConfig) {
    return solution.smart ? this.priceOf(this.products.smartStationOption$) : of(0);
  }
}
